let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("cM9em"), load("fr9NE"), load("gyaYr")]).then(() => parcelRequire('4XV6O'));